import React, { useRef, useState } from 'react';
import { motion, useMotionValue, useSpring, useTransform } from 'framer-motion';

const MagneticButton = ({ children, className = '', onClick, href, to, component: Component, ...props }) => {
    const ref = useRef(null);
    const [isHovered, setIsHovered] = useState(false);

    const x = useMotionValue(0);
    const y = useMotionValue(0);

    const mouseXSpring = useSpring(x, { stiffness: 500, damping: 100 });
    const mouseYSpring = useSpring(y, { stiffness: 500, damping: 100 });

    const rotateX = useTransform(mouseYSpring, [-0.5, 0.5], ['7.5deg', '-7.5deg']);
    const rotateY = useTransform(mouseXSpring, [-0.5, 0.5], ['-7.5deg', '7.5deg']);

    const handleMouseMove = (e) => {
        if (!ref.current) return;

        const rect = ref.current.getBoundingClientRect();
        const width = rect.width;
        const height = rect.height;
        const mouseX = e.clientX - rect.left;
        const mouseY = e.clientY - rect.top;
        const xPct = mouseX / width - 0.5;
        const yPct = mouseY / height - 0.5;

        x.set(xPct);
        y.set(yPct);
    };

    const handleMouseLeave = () => {
        x.set(0);
        y.set(0);
        setIsHovered(false);
    };

    const motionStyle = {
        rotateX: isHovered ? rotateX : 0,
        rotateY: isHovered ? rotateY : 0,
        transformStyle: 'preserve-3d',
    };

    const motionProps = {
        ref,
        className,
        onMouseMove: handleMouseMove,
        onMouseEnter: () => setIsHovered(true),
        onMouseLeave: handleMouseLeave,
        onClick,
        style: motionStyle,
        whileHover: { scale: 1.05 },
        whileTap: { scale: 0.95 },
    };

    if (Component && to) {
        return (
            <motion.div {...motionProps} style={{ display: 'inline-block', ...motionStyle }}>
                <Component to={to} className={className} {...props}>
                    <motion.span
                        style={{
                            display: 'inline-block',
                            transformStyle: 'preserve-3d',
                        }}
                    >
                        {children}
                    </motion.span>
                </Component>
            </motion.div>
        );
    }

    if (href) {
        return (
            <motion.a
                href={href}
                {...motionProps}
                {...props}
            >
                <motion.span
                    style={{
                        display: 'inline-block',
                        transformStyle: 'preserve-3d',
                    }}
                >
                    {children}
                </motion.span>
            </motion.a>
        );
    }

    return (
        <motion.button {...motionProps} {...props}>
            <motion.span
                style={{
                    display: 'inline-block',
                    transformStyle: 'preserve-3d',
                }}
            >
                {children}
            </motion.span>
        </motion.button>
    );
};

export default MagneticButton;

